import { EXPLORER_WORLD_ZOOM, SemanticZoomLevel, semanticZoomLevelToMapLibreZoom } from './semanticZoom';

// Cold-start fallback view, used only as the `??` fallback in MapView when there is no restored
// viewport (shared-link search params / localStorage) or client focal point — it never overrides one.
// Opens at the Network Overview band start so a first-time user lands on the whole-network overview
// (grid tiles). Derived from the semantic ladder so it tracks any future retune of that band.
// This will be replaced in the future based on the network??
export const DEFAULT_INITIAL_VIEW_STATE = {
    longitude: -1.6178,
    latitude: 54.9783,
    zoom: semanticZoomLevelToMapLibreZoom(SemanticZoomLevel.NetworkOverview),
    pitch: 0,
    bearing: 0,
} as const;

// Network Explorer's opening view and its "Reset View" target: the globe with the Atlantic
// in the middle, so Europe, Africa and the Americas — where the estate's clients sit — all
// face the viewer. A shared link's viewport still wins over it, as in the single-client map.
export const EXPLORER_INITIAL_VIEW_STATE = {
    longitude: -10,
    latitude: 30,
    zoom: EXPLORER_WORLD_ZOOM,
    pitch: 0,
    bearing: 0,
} as const;

/**
 * The zoom the map settles at when it is taken to one record — a search result, or a record
 * handed over from the Network Explorer. Well inside the POI band, so the record renders as
 * its own marker rather than inside a cluster.
 */
export const RECORD_FOCUS_ZOOM = 15;
